import { Spin } from "antd";
import React from "react";
import styled from "styled-components";

const LoadingSpin = () => {
  return <CustomSpin fullscreen="true" size="large" />;
};

export default LoadingSpin;

const CustomSpin = styled(Spin)`
  display: flex;
  min-height: 400px;
  justify-content: center;
  align-items: center;
  .ant-spin-dot-item {
    background-color: var(--secondary) !important;
  }
`;
